export default __webpack_public_path__ + "static/media/tictactoe.86d01272.png";